$(function(){
    // スクロールのドラッグ有効化
  jQuery.prototype.mousedragscrollable = function () {
    let target;
    $(this).each(function (i, e) {
      $(e).mousedown(function (event) {
        event.preventDefault();
        target = $(e);
        $(e).data({
          down: true,
          move: false,
          x: event.clientX,
          y: event.clientY,
          scrollleft: $(e).scrollLeft(),
          scrolltop: $(e).scrollTop(),
        });
        return false;
      });
      $(e).click(function (event) {
        if ($(e).data("move")) {
          return false;
        }
      });
    });
    $(document)
      .mousemove(function (event) {
        if ($(target).data("down")) {
          event.preventDefault();
          let move_x = $(target).data("x") - event.clientX;
          let move_y = $(target).data("y") - event.clientY;
          if (move_x !== 0 || move_y !== 0) {
            $(target).data("move", true);
          } else {
            return;
          }
          $(target).scrollLeft($(target).data("scrollleft") + move_x);
          $(target).scrollTop($(target).data("scrolltop") + move_y);
          return false;
        }
      })
      .mouseup(function (event) {
        $(target).data("down", false);
        return false;
      });
  };

  $('.template-cart .side_gift div.more_button').on('click', function() {
    if($(this).hasClass('active')) {
        
      var position = $(".template-cart .side_gift").offset().top - 100;
      $('body,html').animate({scrollTop:position}, 300, 'swing');
      $(this).removeClass('active').find('span').text('OPEN');
      $(this).closest('.template-cart .side_gift').removeClass('open');
    } else {
      $(this).addClass('active').find('span').text('CLOSE');
      $(this).closest('.template-cart .side_gift').addClass('open');
    }
  });

  if($('carousel-navigation').length){
    $('carousel-navigation-inner').mousedragscrollable();
  }
  if($('.breadcrumb_scroll').length){
    $('.breadcrumb_scroll').mousedragscrollable();
  }
  if($('.yoko_scroll').length){
    $('.yoko_scroll').mousedragscrollable();
    $('.yoko_scroll > div').mousedragscrollable();
  }
});